export const SET_ROUTES = 'SET_ROUTES'
export const SET_LIVE = 'SET_LIVE'